import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import LogModal from '../../components/Sales/logModal';

const logModal = reduxForm({
  form: 'logModal'
})(LogModal);

const selector = formValueSelector('logModal');

function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, {})(logModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/logModal.jsx